"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Nav = _styledComponents.default.nav.withConfig({
  displayName: "FilterRow__Nav",
  componentId: "design-system__sc-1fezyj7-0"
})(["box-sizing:border-box;& > *{box-sizing:border-box;}& > ul{display:flex;list-style:none;align-items:center;margin:0;padding:0;height:100%;}& > ul > li{flex:0 0 auto;}& > ul > li + li{margin-left:", ";}"], _BaseTheme.default.distance.small);

const FilterRow = _ref => {
  let {
    children
  } = _ref;
  const [show, setShow] = (0, _react.useState)(false);

  const addDropdownProps = el => _react.default.cloneElement(el, {
    show,
    onToggle: nextShow => setShow(nextShow)
  });

  const renderChildren = c => {
    if (Array.isArray(c)) {
      return c.map((child, index) => {
        const clonnedChild = _react.default.cloneElement(child, {
          key: child.props.title
        });

        if (index === 0) return addDropdownProps(clonnedChild);
        return clonnedChild;
      });
    }

    return addDropdownProps(children);
  };

  if (children === undefined) return /*#__PURE__*/_react.default.createElement(Nav, null);
  return /*#__PURE__*/_react.default.createElement(Nav, null, /*#__PURE__*/_react.default.createElement("ul", null, renderChildren(children)));
};

FilterRow.propTypes = {
  children: _propTypes.default.node
};
FilterRow.defaultProps = {
  children: undefined
};
var _default = FilterRow;
exports.default = _default;